module.exports = "<img [src]=\"imageURL\" name=\"das\" />\r\n"